import React, { Component } from 'react';
import { scaleLinear, scaleOrdinal, scalePow }  from 'd3-scale';
import { arc }  from 'd3-shape';
import { schemeCategory10 }  from 'd3-scale-chromatic';
import Hammer from 'hammerjs';

import { formatYear, formatAxisYear } from './formats';
import { Label }  from './Label';

import './Timewheel.css';

const data = [];
data["de"] = require('./data/data-DE.json');
data["en"] = require('./data/data-EN.json');
data["cz"] = require('./data/data-CZ.json');

class Timewheel extends Component {

  // ["Asia", "Oceania", "Europe", "Africa", "America"]

  colorScale =  scaleOrdinal(schemeCategory10);
  continentScale =  scaleOrdinal([0,1,2,3,4]);
  circularScale =  scaleLinear().range([200, 500]).domain([0,5]);
  radialScale = scaleLinear().domain([-12000, 3000]).range([0, 2*Math.PI]);
  treshold = -1000;
  pinchCenter = null;

  radialScale = function(d) {
    if ( d > this.treshold) {
      return scaleLinear().domain([-12000, 3000])
      .range([0, 2* Math.PI])(d);
    } else {
      return scalePow()
        .exponent(0.4).domain([-380000, 8000])
        .range([0, 2* Math.PI])(d);
    }
  }
  radialTicks = function(d) {
    return (
      scalePow()
        .exponent(0.4).domain([-380000, 8000])
        .range([0, 2* Math.PI])
        .ticks(200)
      .filter(d => d < this.treshold)
      .concat([-9000, -7000, -5000, -3000, -1000])
      .concat([-500, 0, 250, 500, 1000, 1500, 2000])
      //.concat([new Date().getFullYear()])
    )
  }

  constructor(props){
    super(props);

    // bind handlers
    this.onResize = this.onResize.bind(this);
    this.onScrollWheel = this.onScrollWheel.bind(this);

    // init states, scales and other helpers
    this.state = { width: 500, height: 500, scale:1, center:0, radius:420, arcWidth:70 };
    this.state.data = data[props.lang.toLowerCase()];
    this.state.data = this.state.data.sort( function(a,b) { return a.DatumVon_Jahr - b.DatumVon_Jahr} );
    this.state.showCategoryselector = false;

    if ( !this.props.end ) {
      this.state.center = this.radialScale(parseInt(props.start || 0 ));
    } else {
      this.state.center = (this.radialScale(parseInt(props.end))  +  this.radialScale(parseInt(props.start || 0 ))) / 2;
    }

    this.ticks = this.radialTicks();

    this.continents = this.state.data.reduce(function (a, d) {
         if (!a.find ( k => k.id === +d.Kontinent_ID )) {
           a.push({ id: +d.Kontinent_ID, name: d.Kontinent_Name });
         }
         return a;
      }, [])


    // 1 afrika, 2 ameriak, 3, asia, 4 europa, 5 oceania

    //["Asia", "Oceania", "Europe", "Africa", "America"]
    //[3, 5, 4, 1, 2]
    //this.continentScale =  scaleOrdinal().domain(this.continents).range([3,0,4,1,2]);
    this.continentScale =  scaleOrdinal().domain([1,2,3,4,5]).range([1,2,3,4,0]);
    this.categories = this.state.data.reduce(function (a, d) {
         if (a.indexOf(+d.Kategorie_ID) === -1) {
           if (!a.find ( k => k.id === +d.Kategorie_ID )) {
             a.push({ id: +d.Kategorie_ID, name: d.Kategorie_Name });
           }
         }
         return a;
    }, [])

    this.categories = this.categories.sort( function(a,b) { return a.id - b.id} );

    this.categories.push({id:false, name:"ALL"});

    this.state.category = false;

    this.state.rotation = 270
      - this.rad2deg(this.state.center)
      + Math.min(this.rad2deg(Math.atan(window.innerWidth / window.innerHeight)), 45);

    this.state.scale=1;
    this.state.pan= {x:0, y:0};
  }

  componentWillMount() {
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize, false)
    window.addEventListener('wheel', this.onScrollWheel, false)
    window.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });
    this.onResize()
    this.hammer = Hammer(this.node,{  preventDefault: true });
    this.hammer.on('pan', this.onPan.bind(this));
    this.hammer.on('tap', this.onTap.bind(this));
    //this.hammer.on('swipe', this.onSwipe.bind(this));
    //this.hammer.get('pinch').set({ enable: true });
    //this.hammer.on('pinch', this.onPinch.bind(this));
    //this.hammer.on('pinchend', this.onPinchEnd.bind(this));
    //this.hammer.get('rotate').set({ enable: true });
  }

  componentWillUnmount() {
    window.remoEventListener('resize')
    window.remoEventListener('wheel')
    this.hammer.off('pan');
    this.hammer.off('tap');
    //this.hammer.off('pinch');
    //this.hammer.off('swipe');
    //this.hammer.off('rotate');
  }

  onCategorySelect(c) {
      this.setState( {
        category: c,
        data: c === false
          ? data[this.props.lang.toLowerCase()]
          : data[this.props.lang.toLowerCase()].filter(d => +d.Kategorie_ID === c)
      });
      if (c === false)
        this.setState( {showCategoryselector:false});
  }

  showCategoryselector() {
      this.setState( {showCategoryselector:true});
  }

  onResize() {
    var length = window.innerHeight - 40; //Math.min(window.innerWidth, window.innerHeight);
    if (window.innerHeight > window.innerWidth) {
      length = window.innerHeight - 80;
    }
    var arcWidth = (length - 80) / (this.continents.length + 1);

    this.circularScale = scaleLinear()
      .range([arcWidth, length - 80])
      .domain([0, this.continents.length + 1])

    this.setState({
      width: window.innerWidth, //window.innerWidth,
      height: window.innerHeight,
      radius: this.circularScale(this.continents.length),
      arcWidth: arcWidth
    })
  }

  onScrollWheel(e) {
    // on scroll do zoom in

    var scale = Math.max(1, this.state.scale + (e.deltaY > 0 ? -0.1 : 0.1));
    var pt = this.node.createSVGPoint();

    pt.x = e.clientX; pt.y = e.clientY;
    this.setState( { pan: {x:pt.x, y: -(this.state.height - pt.y)} });
    this.setState( { scale: scale })
  }

  onMouseEnterObject(e) {
    var d = this.state.data.find( d=> d.Obj_ID === e.target.id)
    d["pageX"] = e.pageX;
    d["pageY"] = e.pageY;
    this.setState( { highlight: d })
  }

  onMouseLeaveObject(e) {
    this.setState( { highlight: false })
  }

  onPan(e) {
    // on pan rotate
    var dir = e.velocityY > 0 ? 2 : -2;
    var rotation = this.state.rotation +  dir * Math.sqrt( Math.pow(e.velocityY, 2) + Math.pow(e.velocityX, 2)  );
    rotation = Math.max(rotation, -15);
    rotation = Math.min(rotation, 245);
    this.setState( { rotation: rotation })
    e.preventDefault();
  }

  onTap(e) {
    // tap is click
    this.onClick(e);
  }

  onClick(e) {
    var d = this.state.data.find( d=> d.Obj_ID === e.target.id)
    if (d) {
      d["pageX"] = e.pageX;
      d["pageY"] = e.pageY;
      this.setState( { highlight: d })
    } else {
      this.setState( { highlight: false })
    }
  }

  onPinch(e) {
    /*
    // on pinch zoom in
    var scale = 1;
    if (e.scale <= 1) {
      scale= Math.max(1, this.state.scale - e.scale)
    } else {
      scale= Math.max(1, this.state.scale + e.scale)
    }

    Math.max(1, this.state.scale * e.scale)

    var pt = this.node.createSVGPoint();

    if (this.pinchCenter === null) {
      this.pinchCenter = {
        x: e.center.x,
        y: e.center.y,
        scale: this.state.scale
      };
    }
    pt.x = this.pinchCenter.x;
    pt.y = this.pinchCenter.y;
    scale= Math.max(1, this.pinchCenter.scale * e.scale);
    this.setState( { debug_msg: "pinch:" + e.scale
      + " / scale: " + scale +  " / " + this.state.pan.x+ ", " + this.state.pan.y });
    //var scale = Math.max(1, e.scale);
    this.setState( { pan: {x:pt.x, y: -(this.state.height - pt.y)} });
    this.setState( { scale: scale })
    e.preventDefault();

    */
  }

  onPinchEnd(e) {
    //this.pinchCenter = null;
  }

  onSwipe(e) {
    e.preventDefault();
  }

  onRotate(e) {
    // on rotate dp pan
    //console.log(e);
    //var x = Math.min(0,this.state.pan.x + e.velocityX);
    //var y = Math.min(0,this.state.pan.x + e.velocityY);
    //this.setState( { debug_msg: "pan:" + e.velocityX + ", " + e.velocityY })
    //this.setState( { pan: {x:x, y: -(this.state.height - y)} });
    e.preventDefault();
  }

  render() {
    var ringnr = 5;
    var ringpadding = 4;

    if (this.state.radius < 640 || this.state.width < 640 ) {
      ringnr = 4; //3;
      ringpadding = 3;  //2;
    } else if (this.state.radius < 800  || this.state.width < 800 ){
      ringnr = 4;
      ringpadding = 3;
    }

    return (
      <div className="Timewheel" >

        <svg ref={node => this.node = node}
          width={this.state.width} height={this.state.height}>

          <g transform={"translate(15, " + (this.state.height-15) + ")"}>
          <g transform={"translate(" + (this.state.pan.x) + "," + (this.state.pan.y) + "), scale(" + this.state.scale + ")"
            + ",translate(" + (-this.state.pan.x) + "," + (-this.state.pan.y) + ")"}>

            <g transform={"rotate(" + this.state.rotation + ")"}>

              <g className="circularAxis">
                {
                  this.continents.concat({id:0}).map( (d,i) => (
                    <circle key={i} x="0" y="0" r={this.circularScale(d.id)} stroke={this.colorScale(d.id)} />
                  ))
                }
              </g>

              <g className="radialAxis"> {
                  this.ticks.map( (d,i) => (
                    <g key={i} transform={'rotate('
                      + (this.rad2deg(this.radialScale(d)) )
                      + ')'}>
                      <line
                        x1={ this.circularScale(-0.2) }
                        x2={ d % 5000 === 0 ? this.state.radius * 1.05 : this.state.radius * 1.02}
                        style={{
                          opacity: d < -20000 ? '0.7' : '0.9',
                          display: d < -300000 ? "none" : ""
                        }}
                        className= {
                          (d <= -5000 && d % 5000 === 0)
                          || (d > -5000 && d % 1000 === 0 )
                          ? 'hl' : null}
                      />
                      <text x={ this.state.radius * 1.08}>
                        { formatAxisYear(d) }
                      </text>
                    </g>
                  ))
                }
              </g>

              <g className="current"> {
                <g transform={'rotate('
                  + (this.rad2deg(this.radialScale(this.props.start)) )
                  + ')'}>
                  <line
                    x1={ this.circularScale(-0.2) }
                    x2={ this.state.radius * 1.05 }
                  />
                </g> }
                { this.props.end &&
                  <g transform={'rotate('
                    + (this.rad2deg(this.radialScale(this.props.end)) )
                    + ')'}>
                    <line
                      x1={ this.circularScale(-0.2) }
                      x2={ this.state.radius * 1.05 }
                    />
                  </g>
                }
                { this.props.end &&
                  <path d={
                    arc()( {
                      innerRadius: 10,
                      outerRadius: this.state.radius * 1.03,
                      startAngle: this.radialScale(this.props.start) + this.deg2rad(90),
                      endAngle: this.radialScale(this.props.end) + this.deg2rad(90)
                    })
                  } />
                }
                <circle r={ this.circularScale(-0.33) } />

              </g>

              <g className="objects">
              {
                this.state.data.filter(d => d.DatumBis_Jahr != null).map( (d,i) => (
                  <path key={i}
                    d={
                      arc()( {
                       innerRadius: 2 * ringpadding + this.circularScale(this.continentScale(d.Kontinent_ID))
                          + ringpadding + (i % ringnr) * (this.state.arcWidth/(ringnr+1)),
                       outerRadius: this.circularScale(this.continentScale(d.Kontinent_ID))
                          + ringpadding + (i % ringnr) * (this.state.arcWidth/(ringnr+1))
                          + (this.state.arcWidth/(ringnr+1) - ringpadding),
                       startAngle: (this.radialScale(d.DatumVon_Jahr) + this.deg2rad(90)),
                       endAngle: (
                            Math.max(
                             this.radialScale(d.DatumBis_Jahr || d.DatumVon_Jahr ) + this.deg2rad(90),
                             this.radialScale(d.DatumVon_Jahr ) + this.deg2rad(90 + 4)
                           )
                       ) })
                    }
                    fill={ this.colorScale(d.Kontinent_ID) }
                    id={d.Obj_ID}
                    //onMouseEnter={this.onMouseEnterObject.bind(this)}
                    //onMouseLeave={this.onMouseLeaveObject.bind(this)}
                    //onClick={this.onClick.bind(this)}
                    style={
                      this.state.highlight && this.state.highlight.Obj_ID === d.Obj_ID
                        ? {opacity:"1", fill:'#92a05bff'}
                        : {opacity:"1"}
                      }
                  />
                ))
              }
              {
                this.state.data.filter(d => d.DatumBis_Jahr == null).map( (d,i) => (
                  <circle key={i}
                    r={ (this.state.arcWidth/(ringnr+1) - 2 * ringpadding)/2 + 2 }
                    cx={ (this.circularScale(this.continentScale(d.Kontinent_ID))
                        + ringpadding/2 + (i % ringnr) * (this.state.arcWidth/(ringnr+1))
                        + (this.state.arcWidth/(ringnr+1))/2
                       ) * Math.cos(this.radialScale(d.DatumVon_Jahr)) }
                    cy={ (this.circularScale(this.continentScale(d.Kontinent_ID))
                          + ringpadding/2 + (i % ringnr) * (this.state.arcWidth/(ringnr+1))
                            + (this.state.arcWidth/(ringnr+1))/2
                        ) *  Math.sin(this.radialScale(d.DatumVon_Jahr))
                     }
                     fill={ this.colorScale(d.Kontinent_ID) }
                     id={d.Obj_ID}
                     style={
                       this.state.highlight && this.state.highlight.Obj_ID === d.Obj_ID
                         ? {opacity:"1", fill:'#92a05bff'}
                         : {opacity:"1"}
                       }
                     //onMouseEnter={this.onMouseEnterObject.bind(this)}
                     //onMouseLeave={this.onMouseLeaveObject.bind(this)}
                     />
                ))
              }
              </g>
              <g className="current"> {
                <Label
                  x={ this.state.radius * 1.03 * Math.cos((this.state.center))}
                  y={ this.state.radius * 1.03 * Math.sin((this.state.center))}
                  //angle={this.rad2deg(this.state.center) + 45}
                  angle={this.rad2deg(this.state.center) + (90  - Math.min(this.rad2deg(Math.atan(window.innerWidth / window.innerHeight)), 45))}
                  //angle={this.rad2deg(this.state.center) + this.state.rotation - 30}
                  scale="1.3">
                { formatYear(this.props.start) +  ( this.props.end ? " - " +  formatYear(this.props.end) : "" )}
                </Label> }
              </g>

            </g>

            <g className="continentlabels"
            transform={
              window.innerHeight > window.innerWidth
                ?   'translate(20,0),rotate(-90)' : ''
              }
             >
            {
              this.continents.map( (d,i) => (
                <Label key={i}
                  x={ this.circularScale(this.continentScale(d.id) + 0.5  ) }
                  //x={ this.circularScale(this.continentScale(d)) }
                  y={ -10 }
                  angle={0}
                  scale="1.2"
                  width={ this.state.arcWidth * 0.6 }
                  backgroundColor={ this.colorScale(d.id) }
                >
                {  d.name }
                </Label>
              ))
            }
            </g>

          </g>
          </g>

        </svg>

        <div className="categorybutton">
            <button onClick={this.showCategoryselector.bind(this)}>
                <i className="fa fa-list-ul"></i>
              </button>
        </div>

        {this.state.showCategoryselector &&
          <div className="categoryselect">
          {
            this.categories.map( (d,i) => (
              <li key={i}>
                <button onClick={this.onCategorySelect.bind(this, d.id)}
                    className={ d.id === this.state.category ? "active" : ""}>
                {  d.name }
                </button>
              </li>
            ))
          }
          </div>
      }

        <ToolTip data={this.state.highlight}/>

      </div>

    );
  }

  rad2deg(angle) {
    return angle * 180 / Math.PI;
  }

  deg2rad(d) {
    return d / 180 * Math.PI;
  }
}

class ToolTip extends React.Component {
    constructor(props){
      super(props);
      this.state = {data:this.props.data};
    }

    render() {
      var content = ""

      if (this.props.data) {
        var date_str = formatYear(this.props.data.DatumVon_Jahr);
        if (this.props.data.DatumBis_Jahr != null)
          date_str += " - " + formatYear(this.props.data.DatumBis_Jahr);

        content =<div className="tooltip"
          style={{
            //top: Math.min((this.props.data.pageY - 25), window.innerHeight - 180),
            //left: this.props.data.pageX + 10
            top:  (window.innerHeight - 380)/2,
            //left: (window.innerWidth - 500)/2
          }}>
          <img src={window.location.origin + "/" + window.location.pathname + "/" + this.props.data.Img_Link}
            alt="" height="200" />

          <div style={{color:"grey",marginBottom:"0.5em"}}>
            {date_str}
          </div>
          <div className="title">{ this.props.data.Obj_Name }</div>
          <div style={{color:"grey"}}>
            {this.props.data.Kurzbeschreibung}
            </div> <br />
          <div style={{fontSize: "0.7em", textTransform:"uppercase", color:"grey"}}>{this.props.data.Kontinent_Name} / {this.props.data.Kategorie_Name}</div>
        </div>
      }

      return <div>{content}</div>;
  }
}


Timewheel.defaultProps = {
    "start" : 0,
    "end": 1300,
    "lang":"de",
}

export default (Timewheel)
